export const QuoteDivider = () => {
  return (
    <section className="relative py-32 overflow-hidden">
      {/* Background Image */}
      <img 
        src="https://images.unsplash.com/photo-1496080174650-637e3f22fa03?w=1920&q=80"
        alt="Peaceful sunset campfire scene"
        className="absolute inset-0 w-full h-full object-cover"
      />
      
      {/* Overlay Gradient */}
      <div className="absolute inset-0 bg-gradient-to-br from-midnight-green/85 via-deep-teal/80 to-midnight-green/85" />
      
      {/* Quote Content */}
      <div className="relative z-10 max-w-4xl mx-auto px-4 text-center">
        <blockquote className="text-3xl md:text-4xl font-playfair text-ivory leading-relaxed italic mb-8">
          "When food runs smoothly, camp magic happens. That's why we built CampChef Pro — so your kitchen never misses a beat."
        </blockquote>
        
        <div className="flex justify-center gap-8 text-3xl">
          <span className="text-copper">🔥</span>
          <span className="text-copper">🍴</span>
          <span className="text-copper">⛺</span>
        </div>
      </div>
    </section>
  );
};
